export default {
  "nav.overview": "Обзор",
  "nav.transport": "Маршруты",
  "nav.contracts": "Контракты",
  "nav.profitability": "Доходность",
  "nav.market": "Анализ рынка",
  "nav.contact": "Контакты",
  "nav.investNow": "Инвестировать",
  "overview.badge": "Эксклюзивная инвестиционная возможность",
  "overview.line1": "Ормузский пролив",
  "overview.line2": "Закрыт. Саудовская Аравия",
  "overview.line3": "Контролирует всё.",
  "overview.desc": "С закрытием Ормузского пролива <1>Saudi Aramco</1> становится единственным каналом транспортировки нефти из Персидского залива. ОАЭ, Кувейт, Иран — все вынуждены использовать саудовскую инфраструктуру.",
  "overview.subDesc": "Это исторически уникальная ситуация. Войдите в контракт сейчас — пока окно открыто.",
  "overview.viewContracts": "Смотреть контракты",
  "overview.marketAnalysis": "Анализ рынка",
  "overview.stat.barrels": "Баррелей / день",
  "overview.stat.transitShare": "Доля транзита Залива",
  "overview.stat.oilPrice": "Прогноз цены нефти",
  "overview.stat.nations": "Зависимых стран",
  "transport.badge": "Инфраструктура",
  "transport.title1": "Маршруты",
  "transport.title2": "транспортировки",
  "transport.desc": "Когда Ормузский пролив закрыт, все нефтяные потоки Персидского залива перенаправляются через саудовскую инфраструктуру. Никакой альтернативы нет.",
  "transport.route1.title": "Нефтепровод Восток–Запад (Петролайн)",
  "transport.route1.desc": "Главная альтернативная магистраль — 1 200 км от Абкайка до Янбу. Пропускная способность 5 млн барр/день. Единственный обходной маршрут в обход Ормуза.",
  "transport.route1.status": "Активен",
  "transport.route2.title": "Порт Янбу (Красное море)",
  "transport.route2.desc": "Главный терминал экспорта через Красное море. Прямой выход к Суэцкому каналу и европейским рынкам без прохождения через Ормузский пролив.",
  "transport.route2.status": "Активен",
  "transport.route3.title": "Терминал Рас-Тануура",
  "transport.route3.desc": "Крупнейший в мире нефтяной терминал. При закрытом проливе — транзитный узел для ОАЭ, Кувейта и Бахрейна.",
  "transport.route3.status": "Стратегический узел",
  "transport.route4.title": "Нефтеперерабатывающий комплекс Абкайк",
  "transport.route4.desc": "Крупнейший в мире НПК. Перерабатывает нефть соседних стран для транспортировки через саудовские трубопроводы.",
  "transport.route4.status": "Переработка",
  "transport.tableTitle": "Страны, зависящие от саудовского транзита",
  "transport.col.country": "Страна",
  "transport.col.role": "Роль",
  "transport.col.volume": "Суточный объём",
  "transport.role.operator": "Оператор",
  "transport.role.transit": "Транзитный клиент",
  "transport.role.forced": "Вынужденный транзит",
  "contracts.badge": "Инвестиционные планы",
  "contracts.title1": "Выберите",
  "contracts.title2": "Контракт",
  "contracts.desc": "Три уровня инвестиционных контрактов с гарантированной доходностью. Выберите объём участия и получайте прибыль с каждого барреля.",
  "contracts.plan1.name": "Базовый контракт",
  "contracts.plan2.name": "Стандартный контракт",
  "contracts.plan3.name": "Премиум контракт",
  "contracts.plan2.badge": "Наиболее популярный",
  "contracts.plan3.badge": "Максимальный доход",
  "contracts.subLabel": "Транзит Saudi Aramco",
  "contracts.minInvestment": "минимальная инвестиция",
  "contracts.profitRate": "Доходность",
  "contracts.estReturn": "Ожид. доход",
  "contracts.totalPayout": "Итоговая выплата",
  "contracts.getStarted": "Начать →",
  "contracts.plan1.f1": "30% гарантированный доход",
  "contracts.plan1.f2": "Доступ к маршрутам терминала Янбу",
  "contracts.plan1.f3": "Ежемесячная выплата прибыли",
  "contracts.plan1.f4": "Персональный менеджер",
  "contracts.plan1.f5": "Квартальные отчёты по рынку",
  "contracts.plan2.f1": "40% гарантированный доход",
  "contracts.plan2.f2": "Приоритетный доступ к нефтепроводу Восток–Запад",
  "contracts.plan2.f3": "Выплата прибыли раз в две недели",
  "contracts.plan2.f4": "Старший менеджер по работе с клиентами",
  "contracts.plan2.f5": "Еженедельная аналитика рынка",
  "contracts.plan2.f6": "Доступ к вторичным контрактам",
  "contracts.plan3.f1": "50% гарантированный доход",
  "contracts.plan3.f2": "Полный доступ к сети Aramco",
  "contracts.plan3.f3": "Еженедельная выплата прибыли",
  "contracts.plan3.f4": "VIP-менеджер по работе с клиентами",
  "contracts.plan3.f5": "Данные рынка в реальном времени",
  "contracts.plan3.f6": "Приоритетный вариант переконтрактования",
  "contracts.plan3.f7": "Закрытые брифинги для инвесторов",
  "contracts.guaranteeTitle": "Гарантия контракта:",
  "contracts.guaranteeText": "Все контракты обеспечены реальными объёмами транзитной нефти через сеть Saudi Aramco. Выплаты производятся ежемесячно на счёт инвестора после закрытия транзитного цикла.",
  "profitability.badge": "ROI Калькулятор",
  "profitability.title1": "Ваша",
  "profitability.title2": "Доходность",
  "profitability.desc": "Рассчитайте ожидаемый доход в зависимости от суммы инвестиции и выбранного контракта.",
  "profitability.calcTitle": "Инвестиционный калькулятор",
  "profitability.selectTier": "Выберите уровень контракта",
  "profitability.customLabel": "Произвольная сумма инвестиции ($)",
  "profitability.minNote": "Мин: ${{amount}} для этого уровня",
  "profitability.profitRate": "Доходность",
  "profitability.invested": "Вложено",
  "profitability.profit": "Прибыль",
  "profitability.total": "Итого",
  "profitability.scenarioTitle": "Сценарный анализ",
  "profitability.conservative": "Консервативный",
  "profitability.base": "Базовый",
  "profitability.optimistic": "Оптимистичный",
  "profitability.whyTitle": "Почему доходность гарантирована",
  "profitability.why1": "Нефть уже законтрактована — доходность обеспечена реальными поставками",
  "profitability.why2": "Средства размещены в escrow-счёте Saudi National Bank до выплаты",
  "profitability.why3": "Контракт регулируется Saudi Petroleum Authority (SPA)",
  "profitability.why4": "Независимый аудит PWC каждый квартал",
  "market.badge": "Данные и аналитика",
  "market.title1": "Анализ",
  "market.title2": "рынка",
  "market.desc": "Реальные данные о ценах на нефть, объёмах транзита и рыночной динамике в условиях закрытого Ормузского пролива.",
  "market.metric1": "Нефть Brent (текущая)",
  "market.metric2": "Акции Saudi Aramco",
  "market.metric3": "Транзитная премия Залива",
  "market.metric4": "Продолжительность закрытия Ормуза",
  "market.metric4change": "Продолжается",
  "market.chartTitle": "Цена нефти: норма vs. кризис Ормуза",
  "market.normal": "Норма",
  "market.crisis": "Кризис",
  "market.avgIncrease": "средний рост цены в период кризиса",
  "market.newsTitle": "Последние новости",
  "market.tag.breaking": "Срочно",
  "market.tag.deal": "Сделка",
  "market.tag.surge": "Рост цен",
  "market.tag.agreement": "Соглашение",
  "market.news1": "Ормузский пролив: 89% экспорта Персидского залива перенаправлено через саудовские трубопроводы",
  "market.news2": "ОАЭ пересматривает 3-летний транзитный контракт с Saudi Aramco — подписан контракт на $4,2 млрд",
  "market.news3": "Нефть Brent достигла $142/барр. — закрытие Ормуза вошло в 6-ю неделю",
  "market.news4": "Кувейт подписал экстренное транспортное соглашение с Saudi Aramco на 2,8 млн барр/день",
  "market.strategic.badge": "Стратегическая позиция",
  "market.strategic.title": "Саудовская Аравия контролирует 100% альтернативных нефтяных потоков из Залива",
  "market.strategic.desc": "При закрытом Ормузе другие арабские страны вынуждены продавать нефть саудитам по сниженной цене для дальнейшей транспортировки — это многократно усиливает доходность каждого транзитного контракта.",
  "contact.badge": "Связаться с нами",
  "contact.title1": "Начните",
  "contact.title2": "Инвестировать",
  "contact.desc": "Заполните форму — наш менеджер свяжется с вами в течение 24 часов и проведёт через все шаги оформления контракта.",
  "contact.info1.title": "Штаб-квартира",
  "contact.info1.text": "Saudi Aramco HQ, Дахран, Восточная провинция, Саудовская Аравия 31311",
  "contact.info2.title": "Линия для инвесторов",
  "contact.info2.text": "+966 13 872 0115 (Инвест-деск 24/7)",
  "contact.info3.title": "Email",
  "contact.info3.text": "investors@aramco-transit.com",
  "contact.info4.title": "Время ответа",
  "contact.info4.text": "В течение 24 часов — гарантировано",
  "contact.hqLabel": "Saudi Aramco — штаб-квартира в Дахране",
  "contact.hqSub": "Самая дорогая энергетическая компания в мире",
  "contact.formTitle": "Инвестиционная заявка",
  "contact.label.name": "Полное имя",
  "contact.label.email": "Email",
  "contact.label.phone": "Номер телефона",
  "contact.label.contract": "Выберите контракт",
  "contact.label.message": "Сообщение (необязательно)",
  "contact.ph.name": "Иван Иванов",
  "contact.ph.email": "ivan@example.com",
  "contact.ph.phone": "+7 999 000 00 00",
  "contact.ph.message": "Вопросы, инвестиционные цели или дополнительная информация...",
  "contact.opt1": "Базовый контракт — $3 000 (30% прибыли)",
  "contact.opt2": "Стандартный контракт — $5 000 (40% прибыли)",
  "contact.opt3": "Премиум контракт — $10 000 (50% прибыли)",
  "contact.submit": "Отправить заявку на инвестирование →",
  "contact.submitting": "Отправка...",
  "contact.disclaimer": "Отправляя форму, вы соглашаетесь с нашими Условиями. Все инвестиции сопряжены с риском. Прошлые результаты не гарантируют будущих.",
  "contact.successTitle": "Заявка отправлена!",
  "contact.successDesc": "Ваша заявка принята. Инвестиционный менеджер свяжется с вами в течение 24 часов.",
  "contact.anotherRequest": "Отправить ещё заявку",
  "contact.error": "Ошибка отправки. Попробуйте снова.",
  "footer.desc": "Воспользуйтесь уникальной геополитической ситуацией. Инвестируйте в гарантированные нефтяные контракты с Saudi Aramco — единственным оператором транзита нефти из Персидского залива.",
  "footer.navTitle": "Навигация",
  "footer.contractsTitle": "Контракты",
  "footer.readyTitle": "Готовы инвестировать?",
  "footer.readyDesc": "Окно открыто — действуйте сейчас.",
  "footer.viewContracts": "Смотреть контракты",
  "footer.copyright": "© 2026 Saudi Aramco Investment Portal. Все права защищены.",
  "footer.legalNote": "Это инвестиционный портал. Все инвестиции несут риск. Платформа не гарантирует доходность. Проконсультируйтесь с финансовым советником перед инвестированием.",
};
